var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 36.5,
    fill: "#CBCBCB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1067_40763)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M21.9167 37.9583C21.9167 37.2292 22.6459 36.5 23.3751 36.5C24.1042 36.5 24.8334 37.2292 24.8334 37.9583C24.8334 38.4444 24.8334 40.875 24.8334 45.25C24.8334 46.8608 26.1393 48.1667 27.7501 48.1667H45.2501C46.8609 48.1667 48.1668 46.8608 48.1668 45.25V37.9583C48.1668 37.1529 48.8197 36.5 49.6251 36.5C50.4305 36.5 51.0834 37.1529 51.0834 37.9583V45.25C51.0834 48.4717 48.4717 51.0833 45.2501 51.0833H27.7501C24.5284 51.0833 21.9167 48.4717 21.9167 45.25C21.9167 40.875 21.9167 38.4444 21.9167 37.9583Z",
    fill: "#404348"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M37.9584 23.3753C37.9584 22.5699 37.3055 21.917 36.5001 21.917C35.6947 21.917 35.0417 22.5699 35.0417 23.3753V40.8753C35.0417 41.6807 35.6947 42.3337 36.5001 42.3337C37.3055 42.3337 37.9584 41.6807 37.9584 40.8753V23.3753Z",
    fill: "#404348"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5528 23.9259L30.2395 30.2392C29.67 30.8087 28.7467 30.8087 28.1771 30.2392C27.6076 29.6697 27.6076 28.7463 28.1771 28.1768L35.4688 20.8851C36.0173 20.3367 36.8991 20.3135 37.4756 20.8324L44.7672 27.3949C45.3659 27.9337 45.4144 28.8558 44.8756 29.4544C44.3368 30.0531 43.4148 30.1016 42.8161 29.5628L36.5528 23.9259Z",
    fill: "#404348"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1067_40763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(19 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.1ba64c73619f341bbf16e2d8a65af6d4.svg";
export { ForwardRef as ReactComponent };